/* eslint-disable simple-import-sort/imports */

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { CheckIcon } from '@phosphor-icons/react';
import { FC, forwardRef } from 'react';
import useStyles from './style';

interface ISnackBar {
  open: boolean;
  handleClose: () => void;
  severity?: 'success' | 'info' | 'warning' | 'error';
  message?: string;
  duration?: number | null;
}

const SuccessToast = forwardRef<HTMLDivElement, { message: string }>(({ message }, ref) => {
  const classes = useStyles();

  return (
    <div ref={ref} className={classes.successToast} role="alert">
      <span className={classes.successIcon} aria-hidden={true}>
        <CheckIcon size={13} weight="bold" />
      </span>
      <span className={classes.successMessage}>{message}</span>
    </div>
  );
});

SuccessToast.displayName = 'SuccessToast';

const Alert: FC<ISnackBar> = ({ open, handleClose, severity, message, duration }) => {
  const classes = useStyles();
  const isSuccess = severity === 'success';

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={
        isSuccess
          ? { vertical: 'bottom', horizontal: 'right' }
          : { vertical: 'bottom', horizontal: 'center' }
      }
      className={isSuccess ? classes.snackbar : undefined}>
      {isSuccess ? (
        <SuccessToast message={message || ''} />
      ) : (
        <MuiAlert elevation={6} onClose={handleClose} variant="filled" severity={severity}>
          {message || ''}
        </MuiAlert>
      )}
    </Snackbar>
  );
};

export default Alert;
